import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Renderer2 } from '@angular/core';

import { Observable, tap } from 'rxjs';

import { GlobalEvouchersRoutes } from '@hdms/shared/common-types';
import { HeaderModeService } from '@hdms/shared/page-frame/data-access';
import { HeaderMode, ModeType } from '@hdms/shared/page-frame/types';
import { IconsName, SizeOption } from '@hdms/shared/ui-core';

@Component({
  selector: 'shrd-pf-ft-header-logged-mode',
  templateUrl: './header-logged-mode.component.html',
  styleUrls: ['./header-logged-mode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderLoggedModeComponent {
  readonly modeType = ModeType;
  readonly sizeOption = SizeOption;
  readonly iconName = IconsName;
  readonly eVoucherRoute = `/${GlobalEvouchersRoutes.BASE}`;

  readonly modes$ = this.getModes$();

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly headerModeService: HeaderModeService,
    private readonly renderer: Renderer2
  ) {}

  private getModes$(): Observable<HeaderMode[]> {
    return this.headerModeService
      .getMode$()
      .pipe(tap(modes => modes.forEach(m => this.renderer.addClass(this.document.body, m.class))));
  }
}
